import React, { useState, useEffect, useRef } from 'react';
import MapService from './../utils/MapService';
import SearchBar from './bper-search-bar';
import Intro from './bper-intro';
import MapWrapper from './bper-map-wrapper';
import parseHTML from 'html-react-parser';
import { parseRegionURL } from '../utils/Functions';
import { parseRegionName } from '../utils/Functions';

const DEFAULT_ZOOM = 10;

function MapList({ bank, translations, groupId, currentBaseRegion, currentBaseProvince }) {
  const googleMapRef = useRef(null);
  const apiKey = "AIzaSyAceI3L01EHMPh2gWtxOOCdqwvNQn-kx6M"
  const [isGeoloc, setIsGeoloc] = useState(false);
  const [showResults, setShowResults] = useState(currentBaseRegion ? true : false);
  const [apiData, setApiData] = useState(undefined);
  const [configurations, setConfigurations] = useState(undefined);
  const [apiKey2, setApiKey] = useState(undefined);
  const [defaultZoom, setDefaultZoom] = useState(DEFAULT_ZOOM);
  const [userMarkerPosition, setUserMarkerPosition] = useState(undefined);
  const [mapPosition, setMapPosition] = useState(undefined);
  const [place, setPlace] = useState(undefined);
  const [zoom, setZoom] = useState(defaultZoom);
  const [categories, setCategories] = useState(undefined);
  const [openFilter, setOpenFilters] = useState(false);
  const [searchFilter, setSearchFilter] = useState({
    category: undefined,
    services: []
  });

  const [numberOfSearch, setNumberOfSearch] = useState(0);
  const [defaultSearchFilter, setDefaultSearchFilter] = useState(undefined);
  const [locations, setLocations] = useState(undefined);
  const [showLoader, setShowLoader] = useState(false);
  const [activeMarker, setActiveMarker] = useState(undefined);
  const [showServiceInfo, setShowServiceInfo] = useState(undefined);
  const [showButtonRepeatSearch, setShowButtonRepeatSearch] = useState(false);
  const [isDefaultValues, setIsDefaultValues] = useState(true);
  const [regions, setRegions] = useState(false);
  const [currentRegionProvince, setCurrentRegionProvince] = useState({ region: currentBaseRegion, province: currentBaseProvince });
  const [categoriesRegionProvince, setCategoriesRegionProvince] = useState(undefined);
  const [makeSearchCounter, setMakeSearchCounter] = useState(0);
  const [noLocation, setNoLocation] = useState(false);

  const [rnd, setRnd] = useState(0);

  const setDefaultMap = (b) => {
    setIsDefaultValues(b);
  }

  const [token, setToken] = useState("");

  const [token2, setToken2] = useState("");

  const [siteKey2, setSiteKey2] = useState("");

  const [siteKey3, setSiteKey3] = useState("");

  const [typeOfCaptcha, setTypeOfCaptcha] = useState("3");

  const first = useRef(true);
  const tokenRef1 = useRef(null); // Primo riferimento per il token
  const tokenRef2 = useRef(null); // Secondo riferimento per il token
  const typeOfCaptchaRef = useRef(null); // Riferimento per typeOfCaptcha

 
  useEffect(() => {
    if(typeOfCaptchaRef.current == "") {
      typeOfCaptchaRef.current ="3";
    }

    if(typeOfCaptcha == "2") {
      typeOfCaptchaRef.current ="2";
    }
  }, [typeOfCaptcha]);

  const loadRecaptchaScript = (siteKey) => {
    return new Promise((resolve, reject) => {
      if (document.getElementById('recaptcha-script')) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
      script.id = 'recaptcha-script';
      script.onload = () => resolve();
      script.onerror = (error) => reject(error);

      document.body.appendChild(script);
    });
  };

  const getRecaptchaToken = async () => {
    try {

      const siteKey = siteKey3;
      await loadRecaptchaScript(siteKey);
  
      if (window.grecaptcha) {
        window.grecaptcha.enterprise.ready(async () => {
          try {
            const tokentMP = await window.grecaptcha.enterprise.execute(siteKey, { action: 'search' });
            setToken(tokentMP);
            
          } catch (error) {
            console.error('Errore durante l\'esecuzione di reCAPTCHA:', error);
          }
        });
      } else {
        console.error('reCAPTCHA non è caricato correttamente');
      }
    } catch (error) {
      console.error('Errore durante il caricamento dello script reCAPTCHA:', error);
    }
  };

  useEffect(() => {
    const fetchRecaptchaToken = async () => {
      if (siteKey3) {
        await getRecaptchaToken()
      }
    };

    fetchRecaptchaToken();
  }, [siteKey3]);


  useEffect(() => {
    if(first.current == true) {
      if (!(currentRegionProvince && currentRegionProvince.region !== "")) {
        configurations && apiKey && setGeolocationPosition(apiKey, siteKey2);
      }
    }
    
  }, [token]);

  useEffect(() => {
    if (token !==  "" && token !== tokenRef1.current) {
      tokenRef1.current = token;
    }else {

      setToken(tokenRef1.current)
    }
  }, [token]);

  useEffect(() => {
    if (token2 !==  "" && token2 !== tokenRef2.current) {
      tokenRef2.current = token2;
    }else {

      setToken2(tokenRef2.current)
    }
  }, [token2]); // Monitoraggio di token

  // useEffect per typeOfCaptcha con typeOfCaptchaRef
  useEffect(() => {
    if (token !==  "3" && typeOfCaptcha !== typeOfCaptchaRef.current) {
      typeOfCaptchaRef.current = typeOfCaptcha;
    } else {

      setTypeOfCaptcha(typeOfCaptchaRef.current)
    }
  }, [typeOfCaptcha]); // Monitoraggio di typeOfCaptcha

  useEffect(async () => {

    await getConfigurations(bank);
    localStorage.setItem("dottiCount", 0);
    searchByRegion();

  }, []);

  useEffect(() => {
    searchByRegion();
  }, [currentRegionProvince, window.google, regions]);

  /*useEffect(() => {
    if (!(currentRegionProvince && currentRegionProvince.region !== "")) {
      configurations && apiKey && setGeolocationPosition(apiKey);
    }
  }, [apiKey, configurations, window.google, token]);*/


  useEffect(() => {
    configurations && categories === undefined && getRegions(bank, configurations.userCredentials);
    configurations && categories === undefined && getCategories(groupId, bank, configurations.userCredentials);
  }, [configurations]);

  function calcDistanceMatrix(
    google,
    results, // Array dei risultati
    index,
    lat, // Latitudine e longitudine da cui calcolare la distanza
    lng
  ) {

    const distanceMatrixService = new google.maps.DistanceMatrixService();

    index = index || 0;
    if (lat && lng) {
      const origins = [new google.maps.LatLng(lat, lng)];
      const destinations = [];

      let j = 0;
      let size = results.length;

      // I risultati vengono inviati a gruppi di 25, non mi ricordo se è un limite imposto dalle API o era un fatto di performance o simili
      for (let i = index; i < size && j < 25; ++i) {
        j++;
        try {
          let result = results[i];
          destinations.push(new google.maps.LatLng(result.latitude, result.longitude));
        } catch (e) {
          console.error(e);
        }
      }

      if (destinations.length > 0) {
        distanceMatrixService.getDistanceMatrix(
          {
            origins: origins,
            destinations: destinations,
            travelMode: google.maps.TravelMode.DRIVING
          },
          function callback(response, status) {
            try {
              if (status === google.maps.DistanceMatrixStatus.OK) {
                const elements = response.rows[0].elements;
                for (let i = 0; i < elements.length; ++i) {
                  //let result = results[i + index];
                  let distance = '';
                  let distanceValue = 0;
                  if (elements[i].distance) {
                    distance = elements[i].distance.text;
                    distanceValue = parseInt(elements[i].distance.value);
                  }
                  results[i + index].distance = distance;
                  results[i + index].distanceValue = distanceValue;
                }
              } else {
                // Qualcosa è andato storto...
                console.error("Error distance matrix:", status, response);
              }

              let newIndex = index + 25;

              if (newIndex > size - 1) {
                newIndex = size - 1 - newIndex;
              }

              if (newIndex > 0) {
                // La funzione si richiama per calcolare altri 25 punti
                calcDistanceMatrix(
                  google,
                  results,
                  newIndex,
                  lat,
                  lng
                );
              } else {
                // Fine
                setLocations(results);
              }
            } catch (e) {
              console.error("Custom Error a:", e);
            }
          }
        );
      }
    }
  }

  const searchByRegion = () => {
    if (currentRegionProvince && currentRegionProvince.region !== "") {
      window.google && regions && makeSearchByRegion(bank, currentRegionProvince);
      getMyPosition(apiKey);
      /*  window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });*/
    }
  }

  const getRegions = (bank, basic) => {
    MapService.getRegions(bank, basic).then((response) => {
      if (response) {
        setRegions(response?.data?.regionsList);
      }
    });
  };

  const getConfigurations = (bank) => {
    MapService.getConfigurations(bank).then((response) => {
      if (response) {
        setConfigurations(response.data);
        setDefaultZoom(response.data.defaultZoom);

        setZoom(response.data.defaultZoomLevel);
        setApiKey("AIzaSyAceI3L01EHMPh2gWtxOOCdqwvNQn-kx6M");
        setSiteKey2(response.data.recaptchaEnterpriseSiteKeyCheckbox);
        setSiteKey3(response.data.recaptchaV3SiteKey);
        setMapPosition(
          {
            lat: parseFloat(response.data.defaultMapPosition.latitude),
            lng: parseFloat(response.data.defaultMapPosition.longitude)
          }
        );
      }
    });
  };

  const manageSetLocations = (place, loc, manageSetLocations) => {
    if (loc && loc.length > 0) {
      if (manageSetLocations !== -1) {
        place
          ? calcDistanceMatrix(window.google, loc, 0, place.lat, place.lng)
          : setLocations(loc);
      } else {
        setLocations(loc);
      }
    } else {
      setLocations(loc);
    }
  }

  const makeSearchByRegion = (bank, crp, otherCategories) => {
    let categories = [];
    if (crp.region && crp.region !== "") {
      const currentRegionObj = regions.filter(el => parseRegionURL(el.categoryDescription) === parseRegionURL(crp.region));
      const currentRegionId = currentRegionObj && currentRegionObj[0] && currentRegionObj[0].categoryId;
      currentRegionId && categories.push(currentRegionId);

      if (currentRegionObj && currentRegionObj[0] && crp.province && crp.province !== "") {
        const currentProvinceObj = currentRegionObj[0].subFilters.filter(a => parseRegionURL(a.categoryDescription) === parseRegionURL(crp.province))
        const currentProvinceId = currentProvinceObj && currentProvinceObj[0] && currentProvinceObj[0].categoryId;
        currentProvinceId && categories.push(currentProvinceId);
      }
    }

    setCategoriesRegionProvince(categories);

    if (otherCategories) {
      categories = categories.concat(otherCategories)
    }

    try {
      MapService.getRegionSubsidiary(groupId, bank, categories).then((response) => {
        setNumberOfSearch(numberOfSearch + 1);
        const loc = response?.data?.payload?.subsidiaryListGeoloc;

        manageSetLocations(place, loc);

        if (loc) {
          const boundZoom = fitToLocation(loc);

          boundZoom && setZoom(boundZoom);
          setShowResults(true);

          let sumLat = 0;
          let sumLng = 0;
          for (let i = 0; i < loc.length; i++) {
            sumLat += parseFloat(loc[i].latitude);
            sumLng += parseFloat(loc[i].longitude);
          }

          const mapCenter = { lat: sumLat / loc.length, lng: sumLng / loc.length };

          setMapPosition(mapCenter);
          setPlace(mapCenter);

        } else {
          console.warn("Not Loc in this region:", loc);
        }
      })
    } catch (err) {
      console.error("Errore", err);
    };
  }

  const setCaptchaVersion = (str) => {

    setTypeOfCaptcha(str);

  }

  const renderRecaptchaV2 = () => {
    const siteKey = siteKey2;
    const recaptchaElementId = 'html_element';
    const recaptchaElement = document.getElementById(recaptchaElementId);
  
    if (window.grecaptcha) {
      
      if (tokenRef2 && tokenRef2.current && tokenRef2.current.length > 0) {
        window.grecaptcha.reset();
      } else {
        // Se reCAPTCHA non è stato renderizzato, esegui il rendering
        window.grecaptcha.render(recaptchaElementId, {
          sitekey: siteKey,
          callback: (tokenTmp) => {
            setToken2(tokenTmp);
            setCaptchaVersion("2");
          },
          'expired-callback': () => {
            console.log('reCAPTCHA v2 expired');
          },
          'error-callback': () => {
            console.log('reCAPTCHA v2 error');
          }
        });
      }
    } else {
      console.error('reCAPTCHA v2 non è caricato correttamente');
    }
  };
  
  

  const makeSearch = async (filter, place, zoom, zoomOut, distance, isDefaultValuesTmp, type, siteKey2) => {
    //isDefaultValuesTmp = -1 => significa che è la prima ricerca con mappa di default senza geolocalizzazione
    const numberOfResults = configurations.defaultLimitResults;
    const defaultZoomLevelGeo = configurations.defaultZoomLevelGeo;
    const default_zoom_distance = configurations.defaultZoomLevelGeoMobile;
    const selectedZoom = (type === "geo" || type === "place")
      ? defaultZoomLevelGeo
      : (type === "all" || type === "here")
        ? zoom
        : DEFAULT_ZOOM

    localStorage.setItem("search-type", type);

    setZoom(selectedZoom);

    if ((typeOfCaptcha === "3" && token === "") || (typeOfCaptcha === "2" && token2 === "")) {
      // Aggiungi il timeout di 2 secondi
      const timeoutId = setTimeout(() => {
        // Chiama makeSearch dopo 2 secondi
        makeSearch(filter, place, zoom, zoomOut, distance, isDefaultValuesTmp, type, siteKey2);
      }, 2000); // Timeout di 2 secondi
  
      // Pulisci il timeout se il componente viene smontato o se le dipendenze cambiano
      return () => clearTimeout(timeoutId);
    }

    //rimuovo tutte le info su regione e provincia - START
    setCurrentRegionProvince({ region: "", province: "" });
    setCategoriesRegionProvince(undefined);
    //window.history.pushState("", "Filiali", configurations.finderSubsidiaryFriendlyUrl);
    //rimuovo tutte le info su regione e provincia - END

    let newCenter = undefined;

    if (isDefaultValuesTmp!== -1 && place && window.google) {
      localStorage.setItem("place-search", JSON.stringify(place));

      try {
        setLocations(undefined);
              
        MapService.getSubsidiaries(
          bank,
          filter,
          place,
          selectedZoom,
          numberOfResults,
          distance,
          groupId,
          default_zoom_distance,
          typeOfCaptchaRef.current == "3" ? tokenRef1.current : tokenRef2.current,
          typeOfCaptchaRef.current
        ).then((response) => {
          setNumberOfSearch(numberOfSearch + 1);
          const loc = response?.data?.payload?.subsidiaryListGeoloc;

          if(response.data.result && response.data.result == "error") {

            if(typeOfCaptcha == "3") {

              setCaptchaVersion("2");

              console.log("Using recaptcha 2");

              const htmlElement = document.getElementById('html_element_for_error');

              if (htmlElement) {
                  // Crea il nuovo elemento <div>
                  if (!document.getElementById('recaptcha_message')) {
                    const recaptchaMessage = document.createElement('div');
                    recaptchaMessage.id = 'recaptcha_message';
                    recaptchaMessage.className = 'recaptcha-message';
                    recaptchaMessage.textContent = 'Per proseguire conferma di non essere un robot.';

                    // Inserisci il nuovo elemento come primo figlio di htmlElement
                    htmlElement.insertBefore(recaptchaMessage, htmlElement.firstChild);
                  }
              }

              renderRecaptchaV2(); 

            }

            return;

          } else {

            if(typeOfCaptcha == "2") {


              renderRecaptchaV2();

            }

            if(typeOfCaptcha == "3") {

              first.current = false;
              getRecaptchaToken();

            }

          }

          if (response.data.payload === "no data") {
            setNoLocation(true);
            setLocations(undefined);
          } else {
            setNoLocation(false);
            if (!isDefaultValuesTmp && loc /*&& !distance*/) {

              let bounds = new window.google.maps.LatLngBounds();
              loc && loc.forEach(p => {
                bounds.extend(new window.google.maps.LatLng(p.latitude, p.longitude))
              });
              const mapSize = googleMapRef && googleMapRef.current && {
                width: googleMapRef.current.clientWidth,
                height: googleMapRef.current.clientHeight,
              };
              const boundZoom = mapSize && getBoundsZoomLevel(bounds, mapSize);
              //se ci sono location e se non gli ho passato io una distance.
              //io gli passo una distance SOLO se ho cliccato "ricerca-qui"
              boundZoom && setZoom(boundZoom);


              newCenter = bounds.getCenter().lat() !== 0 && Math.abs(bounds.getCenter().lat()) !== 180 && {
                lat: bounds.getCenter().lat(),
                lng: bounds.getCenter().lng(),
              }
              manageSetLocations(place, loc);

              if (newCenter) {
                handleChangeMapCenter(newCenter);
                setPlace(newCenter);
              } else {
                handleChangeMapCenter({ lat: place.lat, lng: place.lng });
              }

            } else {
              handleChangeMapCenter({ lat: place.lat, lng: place.lng });
              manageSetLocations(place, loc);
            }
          }
        });
      } catch (err) {
        console.error("Errore", err);

        if (newCenter) {
          handleChangeMapCenter(newCenter);
          setPlace(newCenter);
        } else {
          handleChangeMapCenter({ lat: place.lat, lng: place.lng });
        }
      };
    }
  };

  const fitToLocation = (loc) => {
    let bounds = new window.google.maps.LatLngBounds();

    loc && loc.forEach(p => {
      bounds.extend(new window.google.maps.LatLng(p.latitude, p.longitude))
    });


    const mapSize = googleMapRef && googleMapRef.current && {
      width: googleMapRef.current.clientWidth,
      height: googleMapRef.current.clientHeight,
    };

    const boundZoom = mapSize && getBoundsZoomLevel(bounds, mapSize);
    return boundZoom;
  }

  const getBoundsZoomLevel = (bounds, mapDim) => {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;

    function latRad(lat) {
      var sin = Math.sin(lat * Math.PI / 180);
      var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
      return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
      return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    if (ne && sw) {
      var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

      var lngDiff = ne.lng() - sw.lng();
      var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

      var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
      var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

      return Math.min(latZoom, lngZoom, ZOOM_MAX);
    } else {
      return undefined;
    }
  }

  const handleOpenFilter = (bool) => {
    bool
      ? document.body.classList.add("show-popup-filiali")
      : document.body.classList.remove("show-popup-filiali");
    setOpenFilters(bool);
  }

  const clickFilialiBper = () => {
    setOpenFilters(false);
  }

  const handleSetPlace = (newPlace) => {
    const dottiCount = parseInt(localStorage.getItem("dottiCount"));
    localStorage.setItem("dottiCount", dottiCount + 1);

    clickFilialiBper();
    setPlace(newPlace);

    //RECUPERO LA DISTANZA A PARTIRE DALLO ZOOM ATTUALE
    const mapCenter = apiData.mapRef?.current?.getCenter();
    const zoom = configurations.defaultZoomLevelGeo;//apiData.mapRef?.current?.getZoom();
    const mapHeight = googleMapRef.current.clientHeight;
    const metersPerPx = 156543.03392 * Math.cos(mapCenter.lat() * Math.PI / 180) / Math.pow(2, zoom);
    //Info here: https://stackoverflow.com/questions/5939983/how-does-this-google-maps-zoom-level-calculation-work
    const distance = mapHeight / 2 * metersPerPx;
    const searchFilter = JSON.parse(localStorage.getItem("subsidiaries-filter"));
    makeSearch(searchFilter, newPlace, distance === 0 ? configurations.defaultZoomLevelGeo : zoom, 0, distance, undefined, "place", siteKey2);
    !showResults && setShowResults(true);
    (zoom === defaultZoom) && setZoom(configurations.defaultZoomLevelGeo); //se lo zoom è rimasto questo di base.. con una ricerca ritorno zoom configurations.defaultZoomLevelGeo in modo da vedere tutta la citta
  };

  const handleHideDotti = () => {
    const dottiCount = localStorage.getItem("dottiCount");
    localStorage.setItem("dottiCount", parseInt(dottiCount) + 1);
    setRnd(Math.random());
  };

  const handleShowServiceInfo = (b) => {
    b
      ? document.body.classList.add("show-popup-filiali")
      : document.body.classList.remove("show-popup-filiali");

    if (document.body.style.overflowY === "hidden") {
      document.body.style.overflowY = "auto";

    } else {
      document.body.style.overflowY = "hidden";
    }
    setShowServiceInfo(b);
    clickFilialiBper();
  }

  const getCategories = (groupId, bank, userCredentials) => {
    MapService.getCategories(groupId, bank, userCredentials).then((response) => {
      const categories = response.data.additionalFilters
      setCategories(categories);
      try {
        const defaultCategory = categories && categories.filter(el => el.categoryName.toLowerCase() === configurations.defaultFilterSelected.toLowerCase())[0];
        defaultCategory && setDefaultSearchFilter(defaultCategory.categoryId);
        const obj = {
          category: defaultCategory.categoryId,
          services: []
        }
        localStorage.setItem("subsidiaries-filter", JSON.stringify(obj));

      } catch (er) {
        console.error("Custom error:", er);
      }
    });
  };

  const updateFilter = (filter) => {
    setSearchFilter(filter);
    localStorage.setItem("subsidiaries-filter", JSON.stringify(filter));
  }

  const handleUpdateSearch = (filter) => {
    setIsDefaultValues(false);
    if (categoriesRegionProvince) {
      let services;
      if (filter) {
        const filterCategory = filter.category;
        const filterServices = filter.services;
        services = filterCategory ? [filterCategory] : [];
        if (filterServices !== undefined) {
          filterServices.forEach((el) => (services.push(el)));
        }
        const obj = {
          category: filterCategory,
          services: filter.services
        }
        localStorage.setItem("subsidiaries-filter", JSON.stringify(obj));
        setSearchFilter(obj);
      }

      makeSearchByRegion(bank, currentRegionProvince, services);
      setIsDefaultValues(false);
      //sono definite categorie per provincia e regione. quindi cerco per provicia e regione + i filtri
    } else {
      //RECUPERO LA DISTANZA A PARTIRE DALLO ZOOM ATTUALE
      //const mapCenter = apiData.mapRef?.current?.getCenter();
      const zoom = apiData.mapRef?.current?.getZoom();
      const mapHeight = googleMapRef.current.clientHeight;
      const metersPerPx = 156543.03392 * Math.cos(place.lat * Math.PI / 180) / Math.pow(2, zoom);
      //Info here: https://stackoverflow.com/questions/5939983/how-does-this-google-maps-zoom-level-calculation-work
      const distance = mapHeight / 2 * metersPerPx;

      if (filter) {
        localStorage.setItem("subsidiaries-filter", JSON.stringify(filter));
        setSearchFilter(filter);
        setMakeSearchCounter(makeSearchCounter + 1);
      }
      makeSearch(filter, place, distance === 0 ? configurations.defaultZoomLevelGeo : zoom, 0, distance, undefined, "place", siteKey2);

      !showResults && setShowResults(true);
      //zoom === defaultZoom && setZoom(15); //se lo zoom è rimasto questo di base.. con una ricerca ritorno zoom 15 in modo da vedere tutta la citta
      setIsDefaultValues(false);
    }
  };

  const handleChangeMapCenter = (pos) => {
    setMapPosition(pos);
  };

  const handleApiLoaded = (obj) => {
    setApiData(obj);
  };

  const handleUpdateZoom = (zoom) => {
    zoom ? setZoom(zoom) : setZoom(defaultZoom);
  };

  const searchHere = (obj) => {
    const searchFilter = JSON.parse(localStorage.getItem("subsidiaries-filter"));
    makeSearch(searchFilter, obj.center, obj.zoom, 0, obj.distance, undefined, "here", siteKey2);
    setMapPosition(obj.center);
    setZoom(obj.zoom);
    setIsDefaultValues(false);
  }

  const handleActiveMarker = (obj) => {
    //setZoom(6);
    setActiveMarker(obj);
    setMapPosition({ lat: obj.lat, lng: obj.lng })
    !showResults && setShowResults(true);

    zoom === defaultZoom && setZoom(15); //se lo zoom è rimasto questo di base.. con una ricerca ritorno zoom 15 in modo da vedere tutta la citta
    setIsDefaultValues(false);
  };

  const getMyPosition = (apiKey) => {
    if (navigator.geolocation) {
      //check if browser support geolocation
      navigator.geolocation.getCurrentPosition(
        function (position) {
          const userPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          if (!(isNaN(position.coords.latitude) || isNaN(position.coords.longitude))) {
            handleChangeMapCenter(userPosition);
            setIsGeoloc(true);
            setPlace(userPosition);
          }
        });
    }
  }

  const setGeolocationPosition = (apiKey, siteKey2) => {
    if (navigator.geolocation) {
      //check if browser support geolocation
      navigator.geolocation.getCurrentPosition(
        function (position) {
          const userPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          if (
            isNaN(position.coords.latitude) ||
            isNaN(position.coords.longitude)
          ) {
            showDefaultMap();
          } else {
            setMapPosition(userPosition);
            setUserMarkerPosition(userPosition);
            setIsGeoloc(true);
            /*
            Geocode.setApiKey(apiKey);
            Geocode.setLanguage('it');
            Geocode.setRegion('it');
            Geocode.enableDebug();
            Geocode.fromLatLng(
              userPosition.lat,
              userPosition.lng
            ).then(
              (response) => {
                const address = response.results[0].formatted_address;*/
            const place = {
              lat: userPosition.lat,
              lng: userPosition.lng,
              //address: address,
              userPosition: true
            };

            setPlace(place);
            const zoomOnSearch = configurations.defaultZoomLevelGeo;

            const mapHeight = googleMapRef.current.clientHeight;
            const metersPerPx = 156543.03392 * Math.cos(place.lat * Math.PI / 180) / Math.pow(2, zoomOnSearch);
            //Info here: https://stackoverflow.com/questions/5939983/how-does-this-google-maps-zoom-level-calculation-work
            const distance = mapHeight / 2 * metersPerPx;
            makeSearch(searchFilter, place, zoomOnSearch, 0, distance, undefined, "geo", siteKey2);
            setShowResults(true);

            const dottiCount = parseInt(localStorage.getItem("dottiCount"));

            if (dottiCount > 0) {
              localStorage.setItem("dottiCount", dottiCount + 1);
            }

          }
        },
        function (el) {
          console.error("Errore geolocalizzazione A", el);
          showDefaultMap();
        }
      );
    }
  };

  const showDefaultMap = () => {
    const place = configurations
      ? {
        lat: parseFloat(configurations.defaultMapPosition.latitude),
        lng: parseFloat(configurations.defaultMapPosition.longitude)
      }
      : undefined;

    setShowResults(false);
    place && setPlace(place);
    place && setMapPosition(place);
    place && setUserMarkerPosition(place);

    place && makeSearch(searchFilter, place, configurations.defaultZoomLevel, -1, undefined, -1, "all", siteKey2);
    setIsDefaultValues(true);
  };

  /*
  const filterByRegion = (e, region, province) => {
    e.stopPropagation();
    e.preventDefault();
    const state = {}
  
    const selectedRegion = region ? regions.filter(el => parseInt(el.categoryId) === parseInt(region))[0] : undefined;
    const selectedProvince = province ? selectedRegion ? selectedRegion.subFilters.filter(el => parseInt(el.categoryId) === parseInt(province))[0] : undefined : undefined;
    //698231
    const url = selectedRegion && selectedProvince
      ? "/" + selectedRegion.categoryDescription + "/" + selectedProvince.categoryDescription
      : selectedRegion
        ? "/" + selectedRegion.categoryDescription
        : undefined;
  
    const title = selectedRegion && selectedProvince
      ? "Filiali BPER " + selectedProvince.categoryDescription + " - " + selectedRegion.categoryDescription
      : selectedRegion
        ? "Filiali BPER " + selectedRegion.categoryDescription
        : undefined;
  
    window.history.pushState(state, title, url);
  
  
    setCurrentRegionProvince({
      region: selectedRegion ? selectedRegion.categoryId : undefined,
      province: selectedProvince ? selectedProvince.categoryId : undefined
    });
  
    return false;
  }*/


  const regionProvinceToShow = regions && regions !== false && (regions && currentRegionProvince.region && currentRegionProvince.region !== "") ? regions.filter(el => parseRegionURL(el.categoryDescription) === currentRegionProvince.region) : regions;
  const selectedRegion = regions && regions !== false && currentRegionProvince?.region !== "" ? regions.filter(el => parseRegionURL(el.categoryDescription) === currentRegionProvince.region)[0] : undefined;
  const selectedProvince = regions && regions !== false && currentRegionProvince?.province !== "" ? selectedRegion ? selectedRegion.subFilters.filter(el => parseRegionURL(el.categoryDescription) === currentRegionProvince.province)[0] : undefined : undefined;

  const padding = 120;
  const showServiceInfoPosition = showServiceInfo && {
    top: showServiceInfo.rect.top,
    left: showServiceInfo.rect.left,
    maxWidth: (window.innerWidth - showServiceInfo.rect.left - 100),
  }

  const textContentHeight = showServiceInfo && { overflowY: "auto", maxHeight: showServiceInfo.rect.top - padding }

  const parseRegionLabel = (el) => el.replace(/-/g, ' ');

  return (
    <div className={"filiali-bper is-default-values-" + isDefaultValues + " geoloc-" + isGeoloc} onClick={() => clickFilialiBper()}>
      {showServiceInfo &&
        <>
          <div className="white-bkg" onClick={() => handleShowServiceInfo(undefined)}></div>
          <div className="service-info-wrapper" style={showServiceInfoPosition}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="dotti">
              <div className="img-dotti"></div>
            </div>
            <div className="text-content" >
              <a className="close" onClick={() => handleShowServiceInfo(undefined)} style={{ opacity: 1 }}>
                {translations.closeButton && translations.closeButton !== "" && <span className="label">{translations.closeButton}</span>}
                <div class="close-circle"></div>
              </a>
              <div className="main-text-content" style={textContentHeight}>
                {showServiceInfo.abstract && parseHTML(showServiceInfo.abstract)}
              </div>
            </div>
          </div>
        </>
      }
      {apiKey && configurations && (
        <>
          <div className="bper-wrapper" id="searchbar-and-intro">
            {
              /* //usano wc statico 
            <Intro selectedRegion={selectedRegion} selectedProvince={selectedProvince} translations={translations} type={categories && categories.filter(el => el.categoryId === searchFilter.category)[0]} />
            */
            }
            {
              /*
              selectedRegion &&
                <h2 className="region-filter-title">
                  {translations.searchSubsidiaryLocation}
                  {selectedRegion.categoryDescription}
                  {
                    selectedProvince &&
                    <> {translations.searchSubsidiaryLocationProvince}<b>{selectedProvince.categoryDescription}</b></>
                  }
                </h2>
                */
            }

            {(noLocation && numberOfSearch !== 0) ?
              <div className="bper-wrapper">
                <h4 style={{ color: "#006369", marginBottom: "40px" }} className="no-results-label">{translations.noResultsLabel}</h4>
              </div>
              : <>
                {
                  locations && locations.length &&
                  <div className="bper-wrapper results-number" style={{ display: "none" }}>
                    <h4 style={{ color: "#006369", marginBottom: "40px" }} className="no-results-label">{translations.nResultsLabel + locations.length}</h4>
                  </div>
                }

              </>
            }
            {categories &&
              <SearchBar
                makeSearchCounter={makeSearchCounter}
                defaultSearchFilter={defaultSearchFilter}
                searchFilter={searchFilter}
                translations={
                  translations
                }
                configurations={configurations}
                resultsNumber={locations ? locations.length : 0}
                apiKey={apiKey}
                apiData={apiData}
                place={place}
                setPlace={handleSetPlace}
                categories={categories}
                updateSearch={handleUpdateSearch}
                //showDotti={dottiCount === 1}
                goToMyPosition={() =>
                  setGeolocationPosition(apiKey)
                }
                hideDotti={handleHideDotti}
                zoom={zoom}
                bank={bank}
                openFilter={openFilter}
                setOpenFilter={handleOpenFilter}
                googleMapRef={googleMapRef}
                groupId={groupId}
                showButtonRepeatSearch={showButtonRepeatSearch}
                searchHere={searchHere}
                setShowButtonRepeatSearch={setShowButtonRepeatSearch}
                showSearchValue={selectedRegion === undefined}
                mapRef={apiData && apiData.mapRef}
                currentRegionProvince={currentRegionProvince}
                regions={regions}
                setDefaultMap={setDefaultMap}
                updateFilter={updateFilter}
              />
            }
          </div>

          <div id="html_element_for_error" className="bper-wrapper" style={{ marginTop: '50px', marginBottom: '20px' }}></div>
          <div id="html_element" className="bper-wrapper" style={{ marginBottom: '50px' }}></div>
          {/*noLocation && numberOfSearch !== 0 &&
            <div className="bper-wrapper">
              <h4 style={{ color: "#006369", marginBottom: "40px" }} className="no-results-label">{translations.noResultsLabel}</h4>
            </div>

          */}
          {mapPosition && (
            <section id="map-section" ref={googleMapRef}>
              {mapPosition && apiKey &&
                <MapWrapper
                  showResults={showResults}
                  translations={translations}
                  configurations={configurations}
                  key="map-wrapper"
                  locations={locations}
                  mapPosition={mapPosition}
                  markerPosition={userMarkerPosition}
                  apiKey={apiKey}
                  onApiLoaded={handleApiLoaded}
                  changeMapCenter={handleChangeMapCenter}
                  zoom={zoom}
                  setZoom={handleUpdateZoom}
                  place={place}
                  activeMarker={activeMarker}
                  updatedSelected={handleActiveMarker}
                  goToMyPosition={() =>
                    setGeolocationPosition(apiKey)
                  }

                  hideDotti={handleHideDotti}
                  searchHere={searchHere}
                  showServiceInfo={showServiceInfo}
                  setShowServiceInfo={handleShowServiceInfo}
                  setShowButtonRepeatSearch={setShowButtonRepeatSearch}
                  isDefaultValues={isDefaultValues}
                />
              }
            </section>
          )}
        </>
      )}
      {regionProvinceToShow && configurations &&
        <div className="bper-wrapper">
          <div className="regions">
            <h2>
              {
                currentRegionProvince.region
                  ? <>

                    {currentRegionProvince.province ?
                      <>
                        {translations.subsidiaryLabelA}
                        <a href={configurations.finderSubsidiaryFriendlyUrl + "/-/dove-siamo/" + parseRegionURL(regionProvinceToShow[0].categoryDescription + "/" + currentRegionProvince.province)}>{parseRegionLabel(currentRegionProvince.province.toUpperCase())}</a>
                        <span> in </span>
                        <a href={configurations.finderSubsidiaryFriendlyUrl + "/-/dove-siamo/" + parseRegionURL(regionProvinceToShow[0].categoryDescription)}>{parseRegionLabel(regionProvinceToShow[0].categoryDescription)}</a>
                      </>
                      :
                      <>
                        {translations.subsidiaryLabelIn}
                        <a href={configurations.finderSubsidiaryFriendlyUrl + "/-/dove-siamo/" + parseRegionURL(regionProvinceToShow[0].categoryDescription)}>{parseRegionLabel(regionProvinceToShow[0].categoryDescription)}</a>
                      </>
                    }
                  </>
                  : <>{translations.subsidiaryLabel}</>
              }
            </h2>
            {
              //onClick={(e) => filterByRegion(e, currentRegionProvince.region, el.categoryId)}
              //onClick={(e) => filterByRegion(e, el.categoryId, undefined)}
            }
            <ul>
              {(currentRegionProvince.region && currentRegionProvince.region !== "")
                ?

                (currentRegionProvince.province === ""
                  ? <>
                    {
                      regionProvinceToShow[0].subFilters.sort((a, b) => (a.categoryDescription > b.categoryDescription) ? 1 : ((b.categoryDescription > a.categoryDescription) ? -1 : 0)).map(el =>
                        <li key={"key_" + el.categoryId} data-id={el.categoryId} className={currentRegionProvince.province && currentRegionProvince.province !== "" && currentRegionProvince.province === parseRegionURL(el.categoryDescription) ? "selected" : ""} data-name={el.categoryName}>
                          <a href={configurations.finderSubsidiaryFriendlyUrl + "/-/dove-siamo/" + parseRegionURL(regionProvinceToShow[0].categoryDescription + "/" + el.categoryDescription)}>
                            {parseRegionName(el.categoryDescription)}
                          </a>
                        </li>
                      )
                    }
                  </>
                  : <>
                    {locations && locations.map(el =>
                      <li key={"key_" + el.id}>
                        <a href={el.linkSubsidiaryCard}>
                          {el.subsidiaryDescription}
                        </a>
                      </li>
                    )}
                  </>
                )
                :
                regionProvinceToShow.sort((a, b) => (a.categoryDescription > b.categoryDescription) ? 1 : ((b.categoryDescription > a.categoryDescription) ? -1 : 0)).map(el =>
                  <li key={"key_" + el.categoryId} data-id={el.categoryId} data-name={el.categoryName}>
                    <a href={configurations.finderSubsidiaryFriendlyUrl + "/-/dove-siamo/" + parseRegionURL(el.categoryDescription)}>
                      {parseRegionName(el.categoryDescription)}
                    </a>
                  </li>
                )
              }
            </ul>
          </div>
        </div>
      }
    </div>
  );
}

export default MapList;
